module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "singup-bg"
  }, [_c('a', {
    staticClass: "page-logo",
    attrs: {
      "href": _vm.index_page
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "action-group"
  }, [_c('a', {
    staticClass: "action-item",
    attrs: {
      "href": _vm.register_page
    }
  }, [_vm._v("注册帐号")])]), _vm._v(" "), _c('div', {
    staticClass: "singup-center",
    staticStyle: {
      "padding-bottom": "32px"
    }
  }, [_c('TabsPane', {
    attrs: {
      "tablist": _vm.tablist
    },
    model: {
      value: (_vm.loginType),
      callback: function($$v) {
        _vm.loginType = $$v
      },
      expression: "loginType"
    }
  }, [_c('div', {
    staticClass: "login-form",
    attrs: {
      "slot": "code"
    },
    slot: "code"
  }, [_c('Form', {
    ref: "loginByCode",
    attrs: {
      "model": _vm.codeForm,
      "rules": _vm.codeFormRules
    }
  }, [_c('FormItem', {
    attrs: {
      "prop": "mobile"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "请输入您的手机号"
    },
    on: {
      "on-enter": _vm.handleSubmit
    },
    model: {
      value: (_vm.codeForm.mobile),
      callback: function($$v) {
        _vm.$set(_vm.codeForm, "mobile", $$v)
      },
      expression: "codeForm.mobile"
    }
  }, [_c('a-icon', {
    attrs: {
      "slot": "prepend",
      "type": "mobile"
    },
    slot: "prepend"
  })], 1)], 1), _vm._v(" "), _c('FormItem', {
    staticClass: "form-item-expand sms-expand",
    attrs: {
      "prop": "sms_code"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "请输入短信验证码"
    },
    on: {
      "on-enter": _vm.handleSubmit
    },
    model: {
      value: (_vm.codeForm.sms_code),
      callback: function($$v) {
        _vm.$set(_vm.codeForm, "sms_code", $$v)
      },
      expression: "codeForm.sms_code"
    }
  }, [_c('a-icon', {
    attrs: {
      "slot": "prepend",
      "type": "safety-certificate"
    },
    slot: "prepend"
  })], 1), _vm._v(" "), _c('button', {
    staticClass: "item-expand",
    attrs: {
      "type": "button",
      "disabled": _vm.waitTime < 60
    },
    on: {
      "click": _vm.sendSms
    }
  }, [_vm._v(_vm._s(_vm.waitTime < 60 ? _vm.waitTime + ' s' : '获取验证码'))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "error-message"
  }, [_vm._v("\n          " + _vm._s(_vm.codeFormError) + "\n        ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "login-form",
    attrs: {
      "slot": "password"
    },
    slot: "password"
  }, [_c('Form', {
    ref: "loginByPassword",
    attrs: {
      "model": _vm.passwordForm,
      "rules": _vm.passwordFormRules
    }
  }, [_c('FormItem', {
    attrs: {
      "prop": "username"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "请输入您的手机号或邮箱"
    },
    on: {
      "on-enter": _vm.handleSubmit
    },
    model: {
      value: (_vm.passwordForm.username),
      callback: function($$v) {
        _vm.$set(_vm.passwordForm, "username", $$v)
      },
      expression: "passwordForm.username"
    }
  }, [_c('a-icon', {
    attrs: {
      "slot": "prepend",
      "type": "mobile"
    },
    slot: "prepend"
  })], 1)], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "prop": "password"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "请输入您的密码",
      "type": "password"
    },
    on: {
      "on-enter": _vm.handleSubmit
    },
    model: {
      value: (_vm.passwordForm.password),
      callback: function($$v) {
        _vm.$set(_vm.passwordForm, "password", $$v)
      },
      expression: "passwordForm.password"
    }
  }, [_c('a-icon', {
    attrs: {
      "slot": "prepend",
      "type": "lock"
    },
    slot: "prepend"
  })], 1)], 1), _vm._v(" "), (_vm.showCaptcha) ? _c('FormItem', {
    staticClass: "form-item-expand pic-expand",
    attrs: {
      "prop": "captcha"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "请输入图形验证码内容"
    },
    model: {
      value: (_vm.passwordForm.captcha),
      callback: function($$v) {
        _vm.$set(_vm.passwordForm, "captcha", $$v)
      },
      expression: "passwordForm.captcha"
    }
  }, [_c('a-icon', {
    attrs: {
      "slot": "prepend",
      "type": "safety-certificate"
    },
    slot: "prepend"
  })], 1), _vm._v(" "), _c('img', {
    staticClass: "item-expand",
    attrs: {
      "src": _vm.passwordCaptchaUrl
    },
    on: {
      "click": _vm.getCaptcha
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "error-message"
  }, [_vm._v("\n          " + _vm._s(_vm.passwordFormError) + "\n        ")])], 1)]), _vm._v(" "), _c('Button', {
    staticClass: "submit-btn",
    attrs: {
      "disabled": !_vm.canSubmit || !_vm.agree,
      "loading": _vm.loading
    },
    on: {
      "click": _vm.handleSubmit
    }
  }, [_vm._v(_vm._s(_vm.btnText))]), _vm._v(" "), _c('Checkbox', {
    staticClass: "agree",
    model: {
      value: (_vm.agree),
      callback: function($$v) {
        _vm.agree = $$v
      },
      expression: "agree"
    }
  }, [_c('div', {
    staticClass: "agree-text"
  }, [_vm._v("我已阅读并同意 "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "/pc/public/assets/privacy_policy.pdf"
    }
  }, [_vm._v("隐私政策")]), _vm._v(" 与 "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "/pc/public/assets/use_agreement.pdf"
    }
  }, [_vm._v("用户使用协议")])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "page-bottom"
  }, [_vm._v("\n    Copyright © 2020 ZAKER.All Rights Reserved\n  ")]), _vm._v(" "), _c('CaptchaModal', {
    attrs: {
      "mobile": _vm.codeForm.mobile
    },
    on: {
      "send-success": _vm.countdown
    },
    model: {
      value: (_vm.showCaptchaModal),
      callback: function($$v) {
        _vm.showCaptchaModal = $$v
      },
      expression: "showCaptchaModal"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9d298824"}!./~/vue-loader/lib/selector.js?type=template&index=0!./pc/index/pages/login.vue
// module id = 844
// module chunks = 4